import { getAssetPath } from '@/constants/configs';
import {
  defaultConfigs,
  getExtraBasicInfoQuestions as defaultGetExtraBasicInfoQuestions,
  resolveICBWebUrl,
} from '@/constants/tenant-configs/default';

import { QuestionCode } from '@/types/api/pep';
import { AppConfigurations } from '@/types/app-configurations';
import { DocumentType } from '@/types/document';
import { Profession, User } from '@/types/user';

import { isBusinessPurposeQuestionEnabled, isMinorUser } from '@/utils/user';

export const anguillaConfigs: AppConfigurations = {
  ...defaultConfigs,
  links: {
    ...defaultConfigs.links,
    privacyPolicyURL:
      'https://www.republicbankanguilla.com/about/privacy-policy',
    termsAndConditionsURL:
      'https://republiconline.republictt.com/ai/legal.html',
    termsOfUseURL: getAssetPath('/tnc/republiconboard-tnc-aia.pdf'),
    appTermsAndConditionsURL: getAssetPath('/tnc/republiconboard-tnc-aia.pdf'),
    biometricConsentURL: getAssetPath(
      '/bio-consent/republiconboard-biometric-consent-aia.pdf',
    ),
    icbWeb: resolveICBWebUrl(
      'https://republiconlineec.rfhl.com/RBEC.UI/#/administrationGeneral/login',
    ),
    icbIOS: 'https://apps.apple.com/us/app/republicmobile-ec/id1582093121',
    icbAndroid:
      'https://play.google.com/store/apps/details?id=ecicprod.com.republicapp',
    eFreeURL: 'https://www.republicbankanguilla.com/personal/e-free-account',
    eFreeUsdURL:
      'https://www.republicbankanguilla.com/personal/e-free-account-usd',
    savingsPlusURL:
      'https://www.republicbankanguilla.com/personal/savings-plus-account',
    usdSavingsURL:
      'https://www.republicbankanguilla.com/personal/usd-savings-account',
  },
  defaultCountryCode: '1264',
  locale: 'en-AI',
  isoCode: 'AIA',
  dateFormat: 'dd/MM/yyyy',
  defaultCurrency: 'XCD',
  idCaptureRequirement: 'passport',
  idDocumentTypes: [DocumentType.Passport],
  minorOnlyIdDocumentTypes: [DocumentType.BirthCertificate],
  existingCustomer: {
    maxAccountsPerType: 2,
  },
  autoApproveUnemployedProfessions: [
    Profession.Pensioner,
    Profession.Housewife,
    Profession.Unemployed,
  ],
  showRiskSectorFlagQuestion: false,
  showSelfEmployedWithRiskSectorFlagQuestion: true,
  jointAccountRelationshipOptions: [
    { value: 'PARENT', i18nKey: 'minorOthers.form.relationship.parent' },
    {
      value: 'LEGAL_GUARDIAN',
      i18nKey: 'minorOthers.form.relationship.legalGuardian',
    },
  ],
};

export const getExtraBasicInfoQuestions = (user: User) => {
  if (isMinorUser(user)) {
    return defaultGetExtraBasicInfoQuestions(user);
  }
  return {
    ...defaultGetExtraBasicInfoQuestions(user),
    [QuestionCode.AccountPurpose]: {
      enabled: isBusinessPurposeQuestionEnabled(user),
      question: 'questionDrawer.accountPurpose.question',
      priority: 0,
    },
  };
};
